//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TSelectPage from '../../CSelect/TSelectPage'
import CBottomButtons from '../../CBottomButtons'
import CJumpPage from '../../CJumpPage'
import TAddGraduationSchool from './TAddGraduationSchool'

export default {
  name: 'BSelectSchoolOtherPage',

  components: {
    CBottomButtons,
    TSelectPage,
    CJumpPage,
  },

  data () {
    return {
      TAddGraduationSchool,
      ...this.$attrs,
      showAddPopup: false,
      bottomButtons: [
        {
          title: '返回',
          key: 'back',
          class: 'back',
          handler: () => {
            this.returnSelect()
          },
        },
        {
          title: '添加中学',
          key: 'add',
          class: 'add',
          handler: () => {
            this.add()
          },
        },
      ],
    }
  },

  computed: {
    innerValue: {
      set (val) {
        this.$emit('input', val)
      },
      get () {
        return this.value
      },
    },
  },

  methods: {
    radioCardClick (item) {
      this.$set(item, 'active', !item.active)
    },

    returnSelect () {
      this.$emit('on-return')
    },

    add () {
      this.showAddPopup = true
      const vm = this.$refs[`c-jump-page-${this._uid}`]

      if (vm) {
        vm.click()
      }
    },

    doReload () {
      this.$refs.tSelectPage.reload()
    },
  },
}
